import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../axiosHttp";
import API_URL from "../../constant/api.config";
import { buildPath, setAuthHeaders } from "../../utils/common";
import CalendarToday from "../../imgs/caledar-today.svg";
import CalendarWeek from "../../imgs/caledar-week.svg";
import CalendarMonth from "../../imgs/caledar-month.svg";
import { useAuth } from "@/AuthProvider";
import roles from "@/constant/roles.config";
import { privateRoutePaths } from "@/routes/private.route.config";

const InquiryCount = () => {

  const { user, isPreKYCUser, isDemoUser, isEndUser, isViewer } = useAuth();

  const initialRef = useRef(true);
  const [todayCount, setTodayCount] = useState(0);
  const [sevenDayCount, setSevenDayCount] = useState(0);
  const [thirtyDayCount, setthirtyDayCount] = useState(0);

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };


  const getInqCounts = async () => {
    const { headers } = setAuthHeaders();
    let InqResponse = await axiosInstance
      .get(
        API_URL + "/inquiry-counts",
        {},
        {
          headers
        }
      );
    if (InqResponse.status === 200) {
      if (InqResponse.data.status === true) {
        setTodayCount(InqResponse.data.data.this_week);
        setSevenDayCount(InqResponse.data.data.this_month);
        setthirtyDayCount(InqResponse.data.data.last_month);
      }
    }
  }

  useEffect(() => {
    if (initialRef.current === true) {
      getInqCounts();
      initialRef.current = false;
    }
  }, [initialRef]);


  const style = {
    //marginTop: "10px",
    marginBottom: "25px"
  }


  return (<>
    <div class="row new-joinee">
      <div className="col-md-12" style={style}>
        <div className="card" >
          <div className="card-title" style={{ paddingTop: "10px", paddingBottom: "5px", paddingLeft: "15px" }}>
            <h5>Total Inquiries</h5>
          </div>
        </div>
      </div>

      <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.ADMIN_INQUIRIES, { fordate: btoa("week") })}`}>

        <div class="col-lg-12 col-md-12 col-6 " style={style}>
          <div class="card card-shadow border-0 h-100">
            <div class="card-body">
              <div className="row">
                {/* <div className="col-6">
                                    <div className="icon">
                                        <img src={CalendarToday} alt="" />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <p class="">Today's Inquiry</p>
                                    <h4 class="card-title">{todayCount}</h4>
                                </div> */}

                {/* <div className="detail">
                                    <p class="">Today's Inquiry</p>
                                    <h4 class="card-title">{todayCount}</h4>
                                </div> */}
                <div className="col-md-4">
                  <div className="icon">
                    <img src={CalendarToday} alt="" />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="detail text-end">
                    <span class="">Weekly</span>
                    <h4 class="card-title">{todayCount}</h4>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
      <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.ADMIN_INQUIRIES, { fordate: btoa("this_month") })}`}>
        <div class="col-lg-12 col-md-12 col-6" style={style}>
          <div class="card card-shadow border-0 h-100">
            <div class="card-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="icon">
                    <img src={CalendarWeek} alt="" />
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="detail text-end">
                    <span class="">Monthly</span>
                    <h4 class="card-title">{sevenDayCount}</h4>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </Link>

      <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.ADMIN_INQUIRIES, { fordate: btoa("last_month") })}`}>
        <div class="col-lg-12 col-md-12 col-6" style={style}>
          <div class="card card-shadow border-0 h-100" >
            <div class="card-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="icon">
                    <img src={CalendarMonth} alt="" />
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="detail text-end">
                    <span class="">Last Month</span>
                    <h4 class="card-title">{thirtyDayCount}</h4>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </Link>


    </div>
  </>)
}

export default InquiryCount;